import { Button } from '@/components/ui/button'

import { toast as message } from 'sonner'

import { LinkIcon, Copy, FileText } from 'lucide-react'

import './AgentSetup.css'

export default function AgentSetup() {
  const instruction = `请阅读 ${window.location.origin}/agent-setup/prompt.md，检查当前项目并协助我接入 KyrenPay 一次性收款。`

  const copyInstruction = async () => {
    try {
      await navigator.clipboard.writeText(instruction)
      message.success('接入指令已复制')
    } catch {
      message.error('复制失败，请选择并复制接入指令')
    }
  }

  return (
    <section aria-labelledby="agent-setup-title" className="agent-setup">
      <div className="agent-setup-heading">
        <h2
          id={'agent-setup-title'}
          style={{ margin: 0 }}
          className="mb-4 text-xl font-semibold tracking-tight"
        >
          AI Agent 接入
        </h2>
        <div className={'flex flex-wrap items-center gap-2'}>
          <a
            href={'/agent-setup/prompt.md'}
            target={'_blank'}
            rel={'noopener noreferrer'}
            className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-primary hover:bg-accent"
          >
            {<FileText />}Prompt
          </a>
          <a
            href={'https://docs.kyrenpay.com/zh/agent-setup'}
            target={'_blank'}
            rel={'noopener noreferrer'}
            className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-primary hover:bg-accent"
          >
            {<LinkIcon />}接入指南
          </a>
        </div>
      </div>
      <p className="agent-setup-instruction">{instruction}</p>
      <Button onClick={copyInstruction} variant={'outline'} type="button">
        {<Copy />}复制接入指令
      </Button>
    </section>
  )
}
